import type { FieldValues, FieldPath } from "react-hook-form";
import { FormField } from "./FormField";
import { CheckboxBlock } from "../ui/CheckboxBlock";
import type { CheckboxProps } from "../ui/Checkbox";

type CheckboxBlockOwnProps = Omit<
  CheckboxProps,
  "className" | "checked" | "onCheckedChange" | "name" | "ref"
>;

interface FormCheckboxBlockProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends CheckboxBlockOwnProps {
  name: TName;
}

export function FormCheckboxBlock<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...checkboxProps }: FormCheckboxBlockProps<TFieldValues, TName>) {
  return (
    <FormField
      name={name}
      render={({ value, onChange, onBlur }) => (
        <CheckboxBlock
          {...checkboxProps}
          checked={!!value}
          onCheckedChange={(checked) => onChange(!!checked)}
          onBlur={onBlur}
        />
      )}
    />
  );
}
